import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { getLangFromPath, stripLang } from '../lib/i18n.js';

const SITE = 'https://etsem.media';
const OG_IMAGE = `${SITE}/og-image.jpg`;
const OG_IMAGE_ALT = 'Etsem Media — The Home of Polo';

export default function SeoHead({
  title,
  description,
  noindex = false,
  type = 'website',
}) {
  const location = useLocation();
  const lang = getLangFromPath(location.pathname);
  const base = stripLang(location.pathname);
  const canonical =
    lang === 'fr' ? (base === '/' ? `${SITE}/fr` : `${SITE}/fr${base}`) : `${SITE}${base}`;
  const altEn = base === '/' ? `${SITE}/` : `${SITE}${base}`;
  const altFr = base === '/' ? `${SITE}/fr` : `${SITE}/fr${base}`;

  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <link rel="alternate" hrefLang="en" href={altEn} />
      <link rel="alternate" hrefLang="fr" href={altFr} />
      <link rel="alternate" hrefLang="x-default" href={altEn} />
      {noindex ? (
        <meta name="robots" content="noindex,nofollow" />
      ) : (
        <meta name="robots" content="index,follow" />
      )}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Etsem Media" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={OG_IMAGE_ALT} />
      <meta property="og:locale" content={lang === 'fr' ? 'fr_FR' : 'en_US'} />
      <meta
        property="og:locale:alternate"
        content={lang === 'fr' ? 'en_US' : 'fr_FR'}
      />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />
      <meta name="twitter:image:alt" content={OG_IMAGE_ALT} />
    </Helmet>
  );
}
